import React from "react";
import { Box, Tab, Chip, Grid, Tabs, Badge, Avatar, Divider, Tooltip } from "@material-ui/core";
import { connect } from "react-redux";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import Patent from "../../../components/Patent";
import Project from "../../../components/Project";
import Solution from "../../../components/Solution";
import Monograph from "../../../components/Monograph";
import ScientificResearch from "../../../components/ScientificResearch";

import { statisticUnaccepted } from "../../../reducer/profile/action";
import { getAllPurpose } from "../../../reducer/scientificResearch/action"; // [VinUni] load mục đích dùng chung
import ContractProfile from "../../User/ContractProfile/ContractProfile";
import { resetPages } from "../../../reducer/home/action";
import noImage from "../../../assets/noimage.png";
import Presentation from "components/Presentation";
import ResearchProposal from "components/ResearchProposal";
import ProgramDirector from "components/ProgramDirector";
import OtherWork from "components/OtherWork";
import StudentGuidance from "components/StudentGuidance";

// [VinUni] TabPanel phải đặt NGOÀI component. Nếu để bên trong, mỗi lần WorkTab
// re-render sẽ tạo function type mới -> React remount toàn bộ nội dung tab ->
// các effect (vd getAllProjectByProfileId) chạy lại liên tục -> gọi API vô tận.
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      {...other}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && children}
    </div>
  );
};

function WorkTab(props) {
  const [value, setValue] = React.useState(0);
  const [count, setCount] = React.useState({});

  const list = window.location.href.split("/");
  const lastValueList = list[list.length - 1].split("=");
  const selectedProfileId = lastValueList.length > 1 ? lastValueList[lastValueList.length - 1] : null;

  const handleChange = (_, newValue) => setValue(newValue);
  const handleReload = () => {
    if (parseInt(selectedProfileId) !== props.profile?.id) {
      props.statisticUnaccepted({ departmentId: 0, profileId: props.profile.id, other: true });
    }
  };

  // [VinUni] Load danh sách "mục đích" 1 lần khi vào trang (mọi tab dùng chung scientificResearchReducer.purposes)
  React.useEffect(() => {
    if ((props.purposes?.length || 0) === 0 && !props.isFetchingPurposes) props.getAllPurpose();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    const temp = props.statisticUnacceptedDetail;
    const countScientificResearch =
      temp?.numJournal +
      temp?.numDomesticJournal +
      temp?.numConference +
      temp?.numDomesticConference +
      temp?.numBook +
      temp?.numOther;
    const countSolution = temp?.numSolution;
    const countPatent = temp?.numPatent;
    const countContract = temp?.numProductContract;
    const countProject = temp?.numResearchProject;
    const countMonograph = temp?.numMonograph;
    const countPresentation = temp?.numPresentation;
    const countResearchProposal = temp?.numResearchProposal;
    const countProgramDirector = temp?.numProgramDirector;
    const countOtherWork = temp?.numOtherWork;
    const countStudentGuidance = temp?.numStudentGuidance;
    setCount({
      scientificResearch: countScientificResearch,
      solution: countSolution,
      patent: countPatent,
      contract: countContract,
      project: countProject,
      monograph: countMonograph,
      presentation: countPresentation,
      researchProposal: countResearchProposal,
      programDirector: countProgramDirector,
      otherWork: countOtherWork,
      studentGuidance: countStudentGuidance,
    });
  }, [props.statisticUnacceptedDetail]);

  // console.log("WorkTab render", count, props.statisticUnacceptedDetail);

  const currentProfile = props.listProfile.find((e) => e.id === parseInt(selectedProfileId || props.profile?.id));

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={12}>
          <Tabs
            value={value}
            scrollButtons="off"
            variant="scrollable"
            textColor="secondary"
            indicatorColor="secondary"
            classes={{
              flexContainer: "flexContainer-tt",
            }}
            onChange={handleChange}
          >
            {props.tabList.map((tab) => (
              <Tab
                key={tab.key}
                label={
                  props.role === "sudo-admin" ? (
                    <Badge color="error" className="work-tab-badge" badgeContent={count[tab.key] || 0}>
                      {tab.title}
                    </Badge>
                  ) : (
                    <>{tab.title}</>
                  )
                }
                style={{ padding: "10px 25px" }}
                classes={{
                  selected: "selected-tt",
                }}
              />
            ))}
          </Tabs>
        </Grid>
        {/* <Grid item xs={2}>
          <Tooltip title="Ấn vào để xem hợp đồng nhân sự">
            <Chip
              size='medium'
              color='primary'
              variant={value === 5 ? 'default' : 'outlined'}
              label={<b>{`Hợp đồng: ${currentProfile?.name}`}</b>}
              avatar={
                <Avatar
                  alt={currentProfile?.name?.split(' ')[-1]?.toUpperCase()}
                  src={currentProfile?.avatar
                    ? `${process.env.REACT_APP_DOMAIN}/api/v1${currentProfile?.avatar}`
                    : noImage}
                />
              }
              style={{ float: 'right', cursor: 'pointer', marginRight: 16 }}
              onClick={() => setValue(5)}
            />
          </Tooltip>
        </Grid> */}
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      {/* [VinUni] Thứ tự: Bài báo, Sách, Đề tài, Giải pháp hữu ích, Bằng sáng chế */}
      <TabPanel value={value} index={0}>
        <ScientificResearch adminTab={false} handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Monograph handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Project handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Solution handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Patent handleReload={handleReload} other />
      </TabPanel>
      {/* [VinUni] Tạm ẩn các công trình khác (giữ code) */}
      {/* <TabPanel value={value} index={5}>
        <Presentation handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <ResearchProposal handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <ProgramDirector handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <OtherWork handleReload={handleReload} other />
      </TabPanel>
      <TabPanel value={value} index={9}>
        <StudentGuidance handleReload={handleReload} other />
      </TabPanel> */}
      {/* <TabPanel value={value} index={5}>
        <ContractProfile profileInfo={currentProfile} />
      </TabPanel> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  listProfile: select(state, "profileReducer", "list"),
  listPatentById: select(state, "patentReducer", "listById"),
  listProjectById: select(state, "projectReducer", "listById"),
  listSolutionById: select(state, "solutionReducer", "listById"),
  listContractById: select(state, "contractReducer", "listById"),
  listMonographById: select(state, "monographReducer", "listById"),
  listPresentationById: select(state, "presentationReducer", "listById"),
  listResearchProposalById: select(state, "researchProposalReducer", "listById"),
  listProgramDirectorById: select(state, "programDirectorReducer", "listById"),
  listOtherWorkById: select(state, "otherWorkReducer", "listById"),

  statisticUnacceptedOther: select(state, "profileReducer", "statisticUnacceptedOther"),
  statisticUnacceptedDetail: select(state, "profileReducer", "statisticUnacceptedDetail"),
  listScientificResearchById: select(state, "scientificResearchReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  isFetchingPurposes: select(state, "scientificResearchReducer", "isFetchingPurposes"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  resetPages: () => dispatch(resetPages()),
  getAllPurpose: () => dispatch(getAllPurpose()),
});

const areEqual = (prevProps, nextProps) =>
  prevProps?.address === nextProps?.address &&
  prevProps?.listProfile === nextProps?.listProfile &&
  prevProps.statisticUnacceptedDetail?.numJournal === nextProps.statisticUnacceptedDetail?.numJournal &&
  prevProps.statisticUnacceptedDetail?.numDomesticJournal === nextProps.statisticUnacceptedDetail?.numDomesticJournal &&
  prevProps.statisticUnacceptedDetail?.numConference === nextProps.statisticUnacceptedDetail?.numConference &&
  prevProps.statisticUnacceptedDetail?.numDomesticConference ===
    nextProps.statisticUnacceptedDetail?.numDomesticConference &&
  prevProps.statisticUnacceptedDetail?.numBook === nextProps.statisticUnacceptedDetail?.numBook &&
  prevProps.statisticUnacceptedDetail?.numOther === nextProps.statisticUnacceptedDetail?.numOther &&
  // && prevProps.statisticUnacceptedDetail?.numWorkingPaper === nextProps.statisticUnacceptedDetail?.numWorkingPaper
  prevProps.statisticUnacceptedDetail?.numSolution === nextProps.statisticUnacceptedDetail?.numSolution &&
  prevProps.statisticUnacceptedDetail?.numPatent === nextProps.statisticUnacceptedDetail?.numPatent &&
  prevProps.statisticUnacceptedDetail?.numProductContract === nextProps.statisticUnacceptedDetail?.numProductContract &&
  prevProps.statisticUnacceptedDetail?.numResearchProject === nextProps.statisticUnacceptedDetail?.numResearchProject &&
  prevProps.statisticUnacceptedDetail?.numMonograph === nextProps.statisticUnacceptedDetail?.numMonograph &&
  prevProps.statisticUnacceptedDetail?.numPresentation === nextProps.statisticUnacceptedDetail?.numPresentation &&
  prevProps.statisticUnacceptedDetail?.numResearchProposal ===
    nextProps.statisticUnacceptedDetail?.numResearchProposal &&
  prevProps.statisticUnacceptedDetail?.numProgramDirector === nextProps.statisticUnacceptedDetail?.numProgramDirector &&
  prevProps.statisticUnacceptedDetail?.numOtherWork === nextProps.statisticUnacceptedDetail?.numOtherWork &&
  prevProps.statisticUnacceptedDetail?.numStudentGuidance === nextProps.statisticUnacceptedDetail?.numStudentGuidance &&
  //
  prevProps.statisticUnacceptedOther?.numJournal === nextProps.statisticUnacceptedOther?.numJournal &&
  prevProps.statisticUnacceptedOther?.numDomesticJournal === nextProps.statisticUnacceptedOther?.numDomesticJournal &&
  prevProps.statisticUnacceptedOther?.numConference === nextProps.statisticUnacceptedOther?.numConference &&
  prevProps.statisticUnacceptedOther?.numDomesticConference ===
    nextProps.statisticUnacceptedOther?.numDomesticConference &&
  prevProps.statisticUnacceptedOther?.numBook === nextProps.statisticUnacceptedOther?.numBook &&
  prevProps.statisticUnacceptedOther?.numOther === nextProps.statisticUnacceptedOther?.numOther &&
  // && prevProps.statisticUnacceptedOther?.numWorkingPaper === nextProps.statisticUnacceptedOther?.numWorkingPaper
  prevProps.statisticUnacceptedOther?.numSolution === nextProps.statisticUnacceptedOther?.numSolution &&
  prevProps.statisticUnacceptedOther?.numPatent === nextProps.statisticUnacceptedOther?.numPatent &&
  prevProps.statisticUnacceptedOther?.numProductContract === nextProps.statisticUnacceptedOther?.numProductContract &&
  prevProps.statisticUnacceptedOther?.numResearchProject === nextProps.statisticUnacceptedOther?.numResearchProject &&
  prevProps.statisticUnacceptedOther?.numMonograph === nextProps.statisticUnacceptedOther?.numMonograph &&
  prevProps.statisticUnacceptedOther?.numPresentation === nextProps.statisticUnacceptedOther?.numPresentation &&
  prevProps.statisticUnacceptedOther?.numResearchProposal === nextProps.statisticUnacceptedOther?.numResearchProposal &&
  prevProps.statisticUnacceptedOther?.numProgramDirector === nextProps.statisticUnacceptedOther?.numProgramDirector &&
  prevProps.statisticUnacceptedOther?.numOtherWork === nextProps.statisticUnacceptedOther?.numOtherWork &&
  //
  prevProps.listPatentById.length === nextProps.listPatentById.length &&
  prevProps.listProjectById.length === nextProps.listProjectById.length &&
  prevProps.listSolutionById.length === nextProps.listSolutionById.length &&
  prevProps.listContractById.length === nextProps.listContractById.length &&
  prevProps.listMonographById.length === nextProps.listMonographById.length &&
  prevProps.listScientificResearchById.length === nextProps.listScientificResearchById.length &&
  prevProps.listPresentationById.length === nextProps.listPresentationById.length &&
  prevProps.listResearchProposalById.length === nextProps.listResearchProposalById.length &&
  prevProps.listProgramDirectorById.length === nextProps.listProgramDirectorById.length &&
  prevProps.listOtherWorkById.length === nextProps.listOtherWorkById.length;

export default connect(mapStateToProps, mapDispatchToProps)(toJs(React.memo(WorkTab, areEqual)));

